// modules
import { handleActions } from 'redux-actions'

// actions
import {
  deletePatientData,
  setIsAddPatientModalVisible,
  setPatientActiveProgram,
  setPatientActivityLog,
  setPatientAllPrograms,
  setPatientAssignedMeasurement,
  setPatientDiseases,
  setPatientGoalInterventions,
  setPatientMeasurementActivityLog,
  setPatientProfile,
  setPatientVitalGraph,
  setPatienttGoals
} from 'src/store/modules/patient/actionCreators'

const initialState = {
  profile: {},
  vitalGraph: {},
  activeProgram: {},
  allPrograms: [],
  assignedMeasurement: [],
  measurementActivityLog: [],
  activityLog: [],
  goals: [],
  diseases: [],
  interventions: {},
  reportGoals: [],
  reportMedications: [],
  isAddPatientModalVisible: false
}

export default handleActions(
  {
    [`${setPatientProfile}`](state: any, { payload: profile }: any) {
      return {
        ...state,
        profile,
        diseases: profile.diseases
      }
    },

    [`${setPatientVitalGraph}`](state: any, { payload: vitalGraph }: any) {
      const { type } = vitalGraph

      return {
        ...state,
        vitalGraph: {
          ...state.vitalGraph,
          [type]: vitalGraph
        }
      }
    },

    [`${setPatientActiveProgram}`](
      state: any,
      { payload: activeProgram }: any
    ) {
      return {
        ...state,
        activeProgram
      }
    },

    [`${setPatientAllPrograms}`](state: any, { payload: allPrograms }: any) {
      return {
        ...state,
        allPrograms
      }
    },

    [`${setPatientAssignedMeasurement}`](
      state: any,
      { payload: assignedMeasurement }: any
    ) {
      return {
        ...state,
        assignedMeasurement
      }
    },

    [`${setPatientMeasurementActivityLog}`](
      state: any,
      { payload: measurementActivityLog }: any
    ) {
      return {
        ...state,
        measurementActivityLog
      }
    },

    [`${setPatientActivityLog}`](state: any, { payload: activityLog }: any) {
      return {
        ...state,
        activityLog
      }
    },

    [`${setPatienttGoals}`](state: any, { payload: goals }: any) {
      return {
        ...state,
        goals
      }
    },

    [`${setPatientGoalInterventions}`](
      state: any,
      { payload: interventions }: any
    ) {
      const { items, patientGoalUuid } = interventions

      return {
        ...state,
        interventions: {
          ...state.interventions,
          [patientGoalUuid]: items
        }
      }
    },

    [`${setIsAddPatientModalVisible}`](
      state: any,
      { payload: isAddPatientModalVisible }
    ) {
      return {
        ...state,
        isAddPatientModalVisible
      }
    },
    [`${setPatientDiseases}`](state: any, { payload: items }) {
      return {
        ...state,
        diseases: items
      }
    },

    [`${deletePatientData}`]() {
      return initialState
    }
  },
  initialState
)
